export const RemoteTableCard = {
  tag: 'button',
  type: 'button',
  flow: 'y',
  gap: 'V',
  padding: 'A',
  round: 'Z1',
  background: 'overlay',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'line',
  cursor: 'pointer',
  textAlign: 'left',
  ':hover': { borderColor: 'title' },
  transition: 'border-color 150ms ease',

  onClick: (e, el, s) => {
    const base = el.parent?.__remoteBasePath || '/data/external'
    const target = el.call('makeRemoteUrl', base, { slug: s.slug, table: s.name })
    const root = el.call('findRouteRoot', el) || el.getRoot()
    if (root) el.router(target, root)
  },

  TopRow: {
    flow: 'x',
    align: 'center space-between',
    gap: 'Z',
    Name: {
      tag: 'span',
      fontSize: 'A',
      fontWeight: '700',
      color: 'title',
      text: (el, s) => s.name
    },
    ColumnCount: {
      padding: 'V Z',
      round: 'Y',
      background: 'overlayStrong',
      color: 'caption',
      fontSize: 'Y1',
      fontWeight: '700',
      text: (el, s) => `${(s.columns || []).length} cols`
    }
  },

  ColumnPreview: {
    tag: 'p',
    fontSize: 'Y2',
    color: 'caption',
    margin: '0',
    lineHeight: '1.4',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
    text: (el, s) => {
      const cols = s.columns || []
      return cols.map((c) => c.name).slice(0, 8).join(', ') + (cols.length > 8 ? '…' : '')
    }
  }
}
